import React from 'react';
import { Link } from 'react-router-dom';
import { products } from '../products';
import { 
    FaCannabis, 
    FaSmoking, 
    FaCookie, 
    FaWineBottle, 
    FaCapsules,
    FaStar,
    FaArrowRight
} from 'react-icons/fa';
import '../css/CategoryList.css';

const categories = [...new Set(products.map(product => product.category))];

// Category icons mapping
const categoryIcons = {
    flower: <FaCannabis />,
    exotics: <FaStar />,
    vapes: <FaSmoking />,
    edibles: <FaCookie />,
    concentrates: <FaWineBottle />,
    prerolls: <FaCapsules />
};

const CategoryList = () => {
    const scrollToProducts = () => {
        const productsSection = document.getElementById('products-section');
        if (productsSection) {
            productsSection.scrollIntoView({ 
                behavior: 'smooth',
                block: 'start'
            });
        }
    };

    return (
        <div className="category-list">
            <div className="category-container">
                <div className="category-header">
                    <h2 className="category-title">Categories</h2>
                    <p className="category-subtitle">Quick access to our collections</p>
                </div>
                
                <div className="categories-grid">
                    {categories.map((category, index) => (
                        <Link 
                            key={index}
                            to={`/category/${category.toLowerCase()}`}
                            className="category-card"
                        >
                            <div className="category-icon">
                                {categoryIcons[category.toLowerCase()] || <FaCannabis />}
                            </div>
                            <span className="category-name">{category}</span>
                        </Link>
                    ))}
                </div>
                
                <div className="category-footer">
                    <button onClick={scrollToProducts} className="view-all-btn">
                        <span>View All Products</span>
                        <FaArrowRight className="btn-icon" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CategoryList;